"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataType = void 0;
const dm_types_1 = require("../generated/dm-types");
var dm_types_2 = require("../generated/dm-types");
Object.defineProperty(exports, "DataType", { enumerable: true, get: function () { return dm_types_2.DataType; } });
